<div class="app-wrapper">
  <app-header-component *ngIf="!shouldHideAppChrome()"></app-header-component>

  <div
    class="pages"
    [class.app-mode-pages]="appModeService.isApp()"
    [class.app-mode-no-chrome]="shouldHideAppChrome()"
  >
    <router-outlet></router-outlet>
  </div>

  <app-bottom-nav *ngIf="appModeService.isApp() && !shouldHideBottomNav()"></app-bottom-nav>
  <app-footer *ngIf="!appModeService.isApp()"></app-footer>
</div>
